<script>
	import { getContext, onMount, createEventDispatcher } from 'svelte';
	import { mapbox, key } from './mapbox.js';
	import getIcon from './icons.js'
	import {map} from './Map.svelte'

	const dispatch = createEventDispatcher();


</script>

<script context="module">

	export function createMapMarker(marker) {
		let {
			// lat, <-- never used
			// long, <-- never used
			// id, <-- never used
			// map_icon <-- never used, and apparently always undefined
			categories,
			primaryCat,
			popup:html,
			coordinates
		} = marker;

		// if there's no primaryCat then try to use first one in categories
		if (!primaryCat && categories && categories.length) {
			primaryCat = categories[0]
		}

		if (coordinates.length > 1) {

			return coordinates.map((coord, i) => {
				const el = createElement(primaryCat)
				const popup = createPopup(html + ` <strong>(${coordinates.length} trailheads in total)</strong>`)

				const splitCoordinates = coord.split(',')
				let lat = splitCoordinates[0]
				let long = splitCoordinates[1]

				const marker = new mapbox.Marker(el)
					.setLngLat([lat, long])
					.setPopup(popup)

				return marker

			})

		} else {

			const el = createElement(primaryCat)
			const popup = createPopup(html)

			let lat = coordinates[0].split(',')[0]
			let long = coordinates[0].split(',')[1]

			const marker = new mapbox.Marker(el)
				.setLngLat([lat, long])
				.setPopup(popup)

			return marker

		}

	}


	function createElement(primaryCat) {
		var el = document.createElement('div');
		el.className = 'marker';
		el.style.backgroundImage = `url(${ getIcon(primaryCat) })`; 
		el.style.width = '30px';
		el.style.height = '30px';
		el.style.backgroundSize = 'contain';
		el.style.backgroundPosition = 'center center';
		el.style.backgroundRepeat = 'no-repeat';
		return el
	}

	function createPopup(html) {
		return new mapbox.Popup({ offset: 25 }).setHTML(html)
	}

</script>

<style>
	:global(button.mapboxgl-popup-close-button) {
		color: #000;
	}
</style>